import styled from 'styled-components';

const Wrapper = styled.div`
  .risk-level {
    width: 6px;
    border-radius: 6px;
    align-self: stretch;
    flex-shrink: 0;

    &.urgent {
      background-color: ${(props) => props.theme.charts.alertRiskUrgent};
    }
    &.medium {
      background-color: ${(props) => props.theme.charts.alertRiskMedium};
    }
    &.low {
      background-color: ${(props) => props.theme.charts.alertRiskLow};
    }
  }

  .map-icon {
    color: ${(props) => props.theme.colors.black};
    flex-shrink: 0;
  }

  .no-assigned-driver {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    gap: 16px;
    height: 52px;
    padding: 8px;
    width: 200px;
    background-color: ${(props) => props.theme.colors.surface_muted};
    color: ${(props) => props.theme.colors.inactive};
    border-radius: 6px;
    font-size: 14px;
  }
`;

export default { Wrapper };
